export default () => {
    return (dispatch, getState) => {
        return getState().getIn(["routes", "location", "state", "dashboard", "id"]);
    };
};
